"use client";
import React from "react";
import {
  FaChalkboardTeacher,
  FaBookOpen,
  FaGraduationCap,
  FaRegLightbulb,
} from "react-icons/fa";

const features = [
  {
    icon: <FaChalkboardTeacher className="text-primaryColor text-4xl mb-4" />,
    title: "أفضل المدرسين",
    desc: "نخبة من أفضل المدرسين المتخصصين في جميع المواد الدراسية.",
  },
  {
    icon: <FaBookOpen className="text-primaryColor text-4xl mb-4" />,
    title: "محتوى تعليمي متكامل",
    desc: "كورسات وكتب وامتحانات شاملة تغطي جميع احتياجات الطالب.",
  },
  {
    icon: <FaGraduationCap className="text-primaryColor text-4xl mb-4" />,
    title: "نتائج متميزة",
    desc: "مساعدة الطلاب على تحقيق التفوق والنجاح في جميع المواد.",
  },
  {
    icon: <FaRegLightbulb className="text-primaryColor text-4xl mb-4" />,
    title: "تجربة تعليمية حديثة",
    desc: "منصة تفاعلية وسهلة الاستخدام مع أحدث التقنيات التعليمية.",
  },
];

const AdvantagesPlatform = () => {
  return (
    <div className="w-full max-w-7xl mx-auto">
      <div className="mb-10 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-white">
          لماذا منصة Eduvalu؟
        </h2>
        <p className="text-lg md:text-xl text-[#C7D0E0] max-w-2xl mx-auto">
          اكتشف المميزات التي تجعل منصتنا الخيار الأفضل للطلاب والمعلمين.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {features.map((feature, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center bg-[#323538] rounded-2xl p-8 shadow-md hover:shadow-xl transition"
          >
            {feature.icon}
            <h3 className="text-xl font-bold text-white mb-2 text-center">
              {feature.title}
            </h3>
            <p className="text-[#C7D0E0] text-center text-base">
              {feature.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdvantagesPlatform;
